import { BBI2O } from "../../data/OSSD/Grade10/BBI2O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function BBI2OPage() {
    return (
        <div>
            <GradeCourseTemplate data={BBI2O} />
        </div>
    )
}